import { Kicker } from "@/components/iris";
import { TriggerPanel } from "@/features/pipeline/trigger-panel";
import { useSSE } from "@/hooks/use-sse";
import { isProdBuild } from "@/lib/env";
import { HealthBanner } from "./health-banner";
import { IngestionHistoryTable } from "./ingestion-history-table";
import { ScraperPanel } from "./scraper-panel";
import { SessionTable } from "./session-table";

export function PipelineTab() {
  const { events, connected } = useSSE("/api/ops/v1/pipeline/live");
  const showScrapers = isProdBuild();

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "var(--iris-s-4)" }}>
      <HealthBanner connected={connected} />

      <TriggerPanel />

      {showScrapers && (
        <>
          <Kicker style={{ marginTop: 8 }}>Live Panels</Kicker>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr",
              gap: "var(--iris-s-4)",
            }}
          >
            <ScraperPanel events={events} />
          </div>
        </>
      )}

      {/* IR-1034 QA: next/last ingestion times now live inside each env frame
          (HealthBanner → EnvKpiGrid), so the standalone NextIngestion card was
          dropped here. The run-history tables stay. */}
      <Kicker style={{ marginTop: 8 }}>Ingestion Runs</Kicker>
      <IngestionHistoryTable env="dev" />
      <IngestionHistoryTable env="prod" />

      <Kicker style={{ marginTop: 8 }}>Reconciliation</Kicker>

      <SessionTable />
    </div>
  );
}
